import React, { useEffect, useRef, useState } from "react";
import api from "../../api/api";
import { useSelector } from "react-redux";
import { FaSearch } from "react-icons/fa";
import MailIcon from '@mui/icons-material/Mail';
import CloseIcon from '@mui/icons-material/Close';
import { getPracticeId } from '../../config/practice';

const EnrollPatient = ({ type,setLimit,     setSelectedTab,isOpen,fetchdata,pidHandled,resetFiltercount, close ,setToastMessage ,setToastSeverity,setOpenToast}) => {
  const STATUS = {
    IDLE: "idle",
    LOADING: "loading",
    FOUND: "found",
    EXISTS: "exists",
    NOT_FOUND: "not_found",
    ERROR: "error",
  };
  const [step, setStep] = useState(1);
  const [deviceList, setDeviceList] = useState([]);
  const [devicesData, setDevicesData] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state
  const [manualEntry, setManualEntry] = useState(false);
  const [adddevicemodal,setAddDevicemodal]=useState(false)
  const [searchResultStatus, setSearchResultStatus] = useState(null);
  const [fetcheddata,setFetchedData]=useState({})
  const [serialNumber, setSerialNumber] = useState("");
  const [deviceNumber, setDeviceNumber] = useState("");
  const [searchStatus, setSearchStatus] = useState(STATUS.IDLE);
  const [deviceType, setDeviceType] = useState("");
  const [details, setDetails] = useState("");
  const loginUser = localStorage.getItem("user");
  const practiseid = getPracticeId();

  useEffect(() => {
    if (isOpen) {
      fetchDevices();
      setSearchStatus(STATUS.IDLE);
      setStep(1);
      
      setSerialNumber("");
      setDeviceNumber("");
      setDeviceType("");
      setDetails("");

      setDeviceList([]);
    }
  
  }, [isOpen]);

  const deviceTypes = [
    { label: "BPP", value: "bpp" },
    { label: "CGM", value: "cgm" },
    { label: "CPAP", value: "cpap" },
    { label: "WLM", value: "wlm" },
    { label: "EKG", value: "ekg" },
  ];

  const fetchDevices = async () => {
    setLoading(true); // Set loading to true before fetching data
    try {
      const response = await api.get(`/v1/${practiseid}/rpm/devices`);
      if (response.status === 200) {
        setDevicesData(response.data);
      }
    } catch (error) {
      console.error("Error fetching devices:", error);
    } finally {
      setLoading(false); // Set loading to false after data is fetched
    }
  };

  const [formData, setFormData] = useState({
    patientid:"",
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    email: "",
    phone: "",
    reminders: "",
    devices: {
      bpp: "",
      cgm: "",
      cpap: "",
      wlm: "",
      ekg: "",
    },
    devicesstate: {
      bpp: false,
      cgm: false,
      cpap: false,
      wlm: false,
      ekg: false,
    },
  });
const handlecleardata=()=>{
  setSearchResultStatus(null)
  setFetchedData({})
    setFormData({
        patientid:"",
        firstName: "",
        lastName: "",
        gender: "",
        dob: "",
        email: "",
        phone: "",
        reminders: "",
        devices: {
          bpp: "",
          cgm: "",
          cpap: "",
          wlm: "",
          ekg: "",
        },
        devicesstate: {
          bpp: false,
          cgm: false,
          cpap: false,
          wlm: false,
          ekg: false,
        },
      })
}

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const timeoutRef = useRef(null);

  const handlesearchChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, patientid: value }));

    // Clear the existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set a new timeout
    timeoutRef.current = setTimeout(() => {
     handlesearch(value)
      // Call the search function here, e.g., handlesearch(value);
    }, 1000);
  };
  const handleDeviceChange = (device, value) => {
    setFormData((prev) => ({
      ...prev,
      devices: { ...prev.devices, [device]: value },
    }));
  };

  const handleDevicestateChange = (device, value) => {
    setFormData((prev) => ({
      ...prev,
      devicesstate: { ...prev.devicesstate, [device]: value }, // Update devicesstate, not devices
    }));
  };

const updateDeviceState = (key, value) => {
  console.log("KEY:", key);
  setFormData((prev) => {
    const updatedDevices = {
      ...prev.devicesstate,
      [key]: value,
    };

    const subscription = Object.keys(updatedDevices)
      .filter((k) => updatedDevices[k])
      .join(",");

    console.log("UPDATED DEVICES:", updatedDevices);
    console.log("SUBSCRIPTION:", subscription);

    return {
      ...prev,
      devicesstate: updatedDevices,
      subscription,
    };
  });
};


const generateEmail = async () => {
  try {
    setLoading(true);
    const emailresp = await api.post(
      `/v1/${practiseid}/rpm/email/create-alias`
    );

    const email =
      emailresp?.data?.newemail ||
      formData.email || "";

    setFormData((prev) => ({
      ...prev,
      email
    }));
    setDeviceNumber(email);
    setLoading(false);
  } catch (error) {
    console.error("Error generating email:", error);
      setToastMessage('Error generating email');
      setToastSeverity('error');
      setOpenToast(true);
      setLoading(false);
  }
};

  const handlesearch = async (value) => {
    if (!value) {
      setSearchStatus(STATUS.IDLE);
      return;
    }

    try {
      setLoading(true);
      setSearchStatus(STATUS.LOADING);

      const response = await api.get(
        `/v1/${practiseid}/patient/${value}/rpm/get-patient`
      );

      if (response.status === 200 && Array.isArray(response.data?.patient)) {
        const filteredPatient = response.data.patient.find(
          (p) => p.patientid == value
        );

        if (filteredPatient) {
          // const emailresp = await api.post(
          //   `/v1/${practiseid}/rpm/email/create-alias`
          // );
          // const email = emailresp?.data?.newemail || filteredPatient.email || "";
          const result = {
            patientid: filteredPatient.patientid,
            firstName: filteredPatient.firstname,
            lastName: filteredPatient.lastname,
            // email,
            phone: filteredPatient.phone,
          };
          // setDeviceNumber(email);
          if (filteredPatient.dob) {
            result.dob = filteredPatient.dob.split(" ")[0];
          }

          if (filteredPatient.gender) {
            result.gender =
              filteredPatient.gender.toLowerCase() === "m"
                ? "Male"
                : filteredPatient.gender.toLowerCase() === "f"
                ? "Female"
                : "";
          }

          if (filteredPatient.reminder !== undefined) {
            result.reminders =
              filteredPatient.reminder === 1 ? "enable" : "disable";
          }

          setFormData((prev) => ({ ...prev, ...result }));
          setSearchStatus(STATUS.FOUND);
          setLoading(false);
        } else {
          setSearchStatus(STATUS.NOT_FOUND);
          setFormData((prev) => ({ ...prev, patientid: "" }));
          handlecleardata();
          setLoading(false);
        }
      } 
      else if (response.status === 201 && response.totalcount > 0) {
        setSearchStatus(STATUS.EXISTS);
        setFormData((prev) => ({ ...prev, patientid: "" }));
        handlecleardata();
        setLoading(false);
      } 
      else {
        setSearchStatus(STATUS.NOT_FOUND);
        setFormData((prev) => ({ ...prev, patientid: "" }));
        handlecleardata();
        setLoading(false);
      }

    } catch (error) {
      console.error(error);
      setSearchStatus(STATUS.ERROR);
      setFormData((prev) => ({ ...prev, patientid: "" }));
      handlecleardata();
      setLoading(false);
    }
};

  const handleSubmit = async(e) => {
    e.preventDefault();
try {
    setLoading(true);
    const deviceFlags = Object.fromEntries(
      Object.entries(formData.devicesstate).map(([key, value]) => [
        key,
        value ? "Y" : "N",
      ])
    );

  const response = await api.post(`/v1/${practiseid}/rpm/create-patient`,{
    "chartid":formData.patientid,
    "firstname": formData.firstName,
    "lastname": formData.lastName,
    "gender": formData.gender==='Male'?'M':"F",
    "dob": formData.dob,
    "email": formData.email,
    "phone": formData.phone,
    ...deviceFlags,
    "subscription": formData.subscription,
    devices: deviceList.map((d) => ({
      devicesno: d.serialNumber,
      devicetype: d.deviceType,
      deviceno: d.deviceNumber,
      devicedtls: d.details,
    })),
    "created_by": "string",
    "reminder": formData.reminders==='enable'?1:0,
  "is_highrisk":0
  })
  if (response.status === 200) {
        setToastMessage(response.message);
        setToastSeverity('success');
        setOpenToast(true);
        resetFiltercount()
        pidHandled.current = false; 
        setLimit(10)
        fetchdata({billeligible:null,billnoteligible:null});
        setSelectedTab(0)
        handlecleardata();
        setLoading(false);
    setTimeout(() => close(false), 1000);
  }else{
    setToastMessage(response.message);
    setToastSeverity('info');
    setOpenToast(true);
    setLoading(false);
  }
} catch (error) {
  setToastMessage('Something went wrong');
  setToastSeverity('error');
  setOpenToast(true);
  setLoading(false);
}
  };

  // const addDevice = async () => {
  //   try {
  //     const response = await api.post(`v1/${practiseid}/rpm_devices/create_device`, {
  //       devicesno: serialNumber,
  //       devicetype: deviceType,
  //       created_by: loginUser,
  //       devicedtls:details,
  //       deviceno:deviceNumber,
  //       // practiceid:practiseid
  //     });

  //     if (response.status === 200) {
  //       // setToastMessage(response.message || "Device added successfully.");
  //       // setToastSeverity("success");
  //       // setOpenToast(true);
  //       setAddDevicemodal(false)
  //       // fetchdata();
  //       fetchDevices();
  //     } else {
  //       // setToastMessage(response.message || "Failed to add device.");
  //       // setToastSeverity("info");
  //       // setOpenToast(true);
  //     }
  //   } catch (error) {
  //     console.error("Error adding device:", error);
  //     // setToastMessage("An error occurred while adding the device.");
  //     // setToastSeverity("error");
  //     // setOpenToast(true);
  //   }
  // };

const validateStep1 = () => {
  let newErrors = {};

  if (!formData.firstName) newErrors.firstName = true;
  if (!formData.lastName) newErrors.lastName = true;
  if (!formData.email) newErrors.email = true;
  if (!formData.phone) newErrors.phone = true;

  const hasError = Object.keys(newErrors).length > 0;

  // setErrors(newErrors);

  if (hasError) {
    setToastMessage("Please enter all required fields.");
    setToastSeverity("error");
    setOpenToast(true);
    return false;
  }

  return true;
};
const handleSave = () => {
  if (!deviceType || !serialNumber) return;

  const newDevice = {
    serialNumber,
    deviceNumber,
    deviceType,
    details,
  };

  setDeviceList((prev) => [...prev, newDevice]);

  // clear fields after adding
  setSerialNumber("");
  setDeviceNumber("");
  setDeviceType("");
  setDetails("");
};

const addDeviceToList = async () => {
  updateDeviceState(deviceType, true);
  if (!deviceType || !serialNumber  || !deviceNumber) {
    setToastMessage("Serial No, device No. & Type required");
    setToastSeverity("warning");
    setOpenToast(true);
    return;
  }

  try {
    setLoading(true);
    const response = await api.post(
      `/v1/${practiseid}/rpm_devices/create_device`,
      {
        devicesno: serialNumber,
        devicetype: deviceType,
        created_by: loginUser,
        devicedtls: details,
        deviceno: deviceNumber,
        practiceid: practiseid,
      }
    );

    if (response.status === 200) {
      // ✅ update UI only after success
      const newDevice = {
        serialNumber,
        deviceNumber,
        deviceType,
        details,
      };

      setDeviceList((prev) => [...prev, newDevice]);
      
      setToastMessage("Device added successfully");
      setToastSeverity("success");
      setOpenToast(true);
      setLoading(false);
      // ✅ clear fields
      setSerialNumber("");
      setDeviceNumber("");
      setDeviceType("");
      setDetails("");
    } else {
      setToastMessage(response.message || "Failed to add device");
      setToastSeverity("info");
      setOpenToast(true);
      setLoading(false);
    }
  } catch (error) {
    console.error("Error adding device:", error);
    setLoading(false);
    setToastMessage(
      error?.response?.data?.message || "Something went wrong"
    );
    setToastSeverity("error");
    setOpenToast(true);
  }
};



  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 h-auto overflow-scroll custom-scrollbar" style={{scrollbarWidth:'none'}}>
          <div className="bg-white rounded-lg shadow-lg md:max-w-[50%]  mx-4 sm:mx-auto my-4 ">
            {/* Modal Header */}
            <div className="flex justify-between items-center border-b p-2 px-4 bg-[#E179544A]">
              {/* <h2 className="text-lg font-font1">{adddevicemodal?"ADD DEVICE":"ADD PATIENT"}</h2> */}

              <h2 className="text-lg font-font1">
                {adddevicemodal
                  ? "ADD DEVICE"
                  : step === 1
                  ? "ADD PATIENT"
                  : "ADD DEVICE"}
              </h2>
              <button
               onClick={() => {
                if(adddevicemodal){
                  setAddDevicemodal(false)
                  return
                }
                  handlecleardata()
                  close(false)}}
                className="text-gray-500 hover:text-gray-700"
              >
                <CloseIcon style={{width:"22px"}}/>
              </button>
            </div>

            {/* Modal Content */}
            {!adddevicemodal?   <div className="p-6">
              {false? (
                <div className="flex justify-center items-center py-6">
                  <span className="text-xl text-blue-500">Getting Devices...</span>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>

{step === 1 && (
  <>                      
                      <div className="mb-4 flex items-center">
                    {/* Search input with icon */}
                    
              
                    <input
  value={formData.patientid}
  onChange={handlesearchChange}
  type="text"
  className="w-full px-4 py-1 border rounded-md focus:ring focus:ring-blue-300 outline-none"
  placeholder="Search by patient ID"
  pattern="\d*" // This restricts input to numbers (works on some browsers)
  onInput={(e) => e.target.value = e.target.value.replace(/\D/, '')} // This will remove any non-digit character typed
  onKeyDown={(e) => {
      if (e.key === 'Enter') {
        handlesearchChange(e);
        e.preventDefault();
      }
    }}
/>

                  </div>

<div className="mt-2 text-sm text-left">
  {searchStatus === STATUS.LOADING && (
    <span className="text-blue-500">Searching, please wait...</span>
  )}

  {/* {searchStatus === STATUS.FOUND && (
    <span className="text-green-600">Patient found</span>
  )} */}

  {searchStatus === STATUS.EXISTS && (
    <span className="text-yellow-600">
      Patient already exists in the list
    </span>
  )}

  {searchStatus === STATUS.NOT_FOUND && (
    <span className="text-red-500">No data found</span>
  )}

  {searchStatus === STATUS.ERROR && (
    <span className="text-red-600">
      Something went wrong. Please try again.
    </span>
  )}
</div>

                    {/* <div className="w-full flex justify-between py-2">
  <div className="font-semibold  text-16px">Manual Entry</div>
    
  <div> 
  <div class="flex items-center space-x-4 ">
       <button
    //  onClick={()=>setAddDevicemodal(true)}
        className="px-2 py-1 bg-[#FEFCE8] text-[#A16207] mb-2 rounded-md border-[1.2px] border-[#ccc] "
      >
      + Add Device
      </button>
  <label   for="toggle" class="relative inline-block w-10 h-6">
    <input onChange={() => setManualEntry(!manualEntry)} checked={manualEntry} type="checkbox" id="toggle" class="absolute opacity-0 w-0 h-0 peer" />
    <span class="block w-full h-full bg-gray-300 rounded-full cursor-pointer peer-checked:bg-orange-500 transition-all"></span>
    <span class="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-all peer-checked:translate-x-4"></span>
  </label>
  </div>
</div>
</div> */}
                  <div className="grid font-font1 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
                    {/* First Name */}
                    <div>
                      <label className="block font-font1  font-[14px] text-gray-700  mb-2 text-left">
                        First Name
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        disabled={!manualEntry}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
                        placeholder="Enter first name"
                      />
                    </div>

                    {/* Last Name */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-2 text-left">
                        Last Name
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        disabled={!manualEntry}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
                        placeholder="Enter last name"
                      />
                    </div>

                    {/* Gender */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-2 text-left">
                        Gender
                      </label>
                      <select
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        disabled={!manualEntry}
                        className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>

                    {/* Date of Birth */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-2 text-left">
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        name="dob"
                        value={formData.dob}
                        onChange={handleChange}
                        disabled={!manualEntry}
                        className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
                      />
                    </div>

                    {/* Email */}
<div>
  {/* Label + Icon */}
  <div className="flex items-center justify-between mb-2">
    <label className="text-gray-700 font-medium">
      Email
    </label>

    <button
      type="button"
      onClick={generateEmail}
      className="flex items-center gap-1 px-2 py-1 rounded-sm bg-[#D97842] text-white text-xs hover:bg-[#c86a3a] disabled:opacity-50 disabled:cursor-not-allowed"
      title="Generate Email" disabled={!formData.firstName || !formData.lastName }
    > <MailIcon size={10} /> Generate Email      
    </button>
  </div>

  {/* Input */}
  <input
    type="email"
    name="email"
    value={formData.email}
    className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
    placeholder="Generate email"
    readOnly
  />
</div>

                    {/* Phone */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-2 text-left">
                        Phone
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none"
                        placeholder="Enter phone number"
                        disabled={!manualEntry}
                      />
                    </div>

                    {/* Send Reminders */}
                    <div className="sm:col-span-2">
                      <label className="block text-gray-700 font-medium mb-2 text-left">
                        Send Reminders
                      </label>
                      <div className="flex items-center space-x-4">
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name="reminders"
                            value="enable"
                            checked={formData.reminders === "enable"}
                            onChange={handleChange}
                            className="mr-2"                            
                          />
                          Enable
                        </label>
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name="reminders"
                            value="disable"
                            checked={formData.reminders === "disable"}
                            onChange={handleChange}
                            className="mr-2"                            
                          />
                          Disable
                        </label>
                      </div>
                    </div>
                  </div>

{/* Next Button */}
    <div className="flex justify-end mt-4">
      <button
        type="button"
        onClick={() => {
          if (validateStep1()) {
            setStep(2);
          }
        }}
        className="px-4 py-2 bg-[#D97842] text-white rounded-md"
        disabled={!formData.firstName ||
          !formData.lastName ||
          !formData.email ||
          !formData.phone
        }
      >
        Next →
      </button>
    </div>
  </>
)}



{step === 2 && (
  <>

<div className="grid grid-cols-2 gap-4 mt-1 text-start px-4">




  {/* Serial No */}
  <div className="">
    <label className="text-sm font-medium text-gray-700">
      Serial No *
    </label>
    <input
      type="text"
      className="mt-1 w-full px-3 py-2 border rounded-md"
      placeholder="Enter Serial No"
      value={serialNumber}
      onChange={(e) => setSerialNumber(e.target.value)}
    />
  </div>

  {/* Device No */}
  <div>
    <label className="text-sm font-medium text-gray-700">
      Device No (Email) *
    </label>
    <input
      type="text"
      className="mt-1 w-full px-3 py-2 border rounded-md"
      placeholder="Enter Device No"
      value={deviceNumber}
      onChange={(e) => setDeviceNumber(e.target.value)} readOnly
    />
  </div>

  {/* Type */}
  <div>
    <label className="text-sm font-medium text-gray-700">
      Type *
    </label>
    <select
      className="mt-1 w-full px-3 py-2 border rounded-md"
      value={deviceType}
      onChange={(e) => setDeviceType(e.target.value)}
    >
      <option value="">Select Type</option>
      {deviceTypes.map((type) => (
        <option key={type.value} value={type.value}>
          {type.label}
        </option>
      ))}
    </select>
  </div>

  {/* Details */}
  <div className="d-none">
    <label className="text-sm font-medium text-gray-700">
      Details
    </label>
    <input
      type="text"
      className="mt-1 w-full px-3 py-2 border rounded-md"
      placeholder="Enter Details"
      value={details}
      onChange={(e) => setDetails(e.target.value)}
    />
  </div>
</div>



<div className="flex gap-2 flex justify-end mt-2 p-1">

<button
  type="button"
  onClick={addDeviceToList}
  className="px-4 py-2 bg-[#E17954] text-white rounded-md"
>
  + Add Device
</button>

</div>




{deviceList.length > 0 && (
  <div className="mt-4 px-4">
    <h3 className="font-semibold mb-2">Added Devices</h3>

    <div className="overflow-x-auto border rounded-md">
      <table className="min-w-full text-sm text-left">
        <thead className="bg-gray-100 text-gray-700">
          <tr>
            <th className="px-4 py-2">#</th>
            <th className="px-4 py-2">Type</th>
            <th className="px-4 py-2">Serial No</th>
            <th className="px-4 py-2">Device No</th>
            {/* <th className="px-4 py-2">Action</th> */}
          </tr>
        </thead>

        <tbody>
          {deviceList.map((device, index) => (
            <tr key={index} className="border-t">
              <td className="px-4 py-2">{index + 1}</td>
              <td className="px-4 py-2 uppercase">
                {device.deviceType}
              </td>
              <td className="px-4 py-2">
                {device.serialNumber}
              </td>
              <td className="px-4 py-2">
                {device.deviceNumber}
              </td>
              {/* <td className="px-4 py-2">
                <button
                  onClick={() =>
                    setDeviceList((prev) =>
                      prev.filter((_, i) => i !== index)
                    )
                  }
                  className="text-red-500 hover:underline"
                >
                  Remove
                </button>
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}



          {/* Modal Footer */}
          <div className="flex justify-between mt-2 p-2">
            <div>
<button
  type="button"
  onClick={() => setStep(1)}
  className="px-4 py-2 border rounded-md"
>
  ← Back
</button>
</div>
<div className="flex justify-end  p-2">
                    <button
                      onClick={() => {
                        handlecleardata()
                        close(false)}}
                      className="px-4 py-2 bg-white border-[1.5px] border-gray-200 text-grey-200 rounded-md hover:bg-gray-300 mr-2"
                    >
                      Cancel
                    </button>

<button
  type="submit"
  className={`px-4 py-2 rounded-md ${
    deviceList.length === 0
      ? "bg-gray-300 text-white cursor-not-allowed"
      : "bg-[#D97842] text-white"
  }`}
  disabled={deviceList.length === 0}
>
  Save
</button>
</div>



                  </div>

</>
)}

                </form>
              )}
                  </div>:<div className="p-4">
           
           <form className="grid grid-cols-2 gap-4 mt-4 text-start">
           {/* Serial No */}
           <div>
             <label className="block text-sm font-medium text-gray-700">
               Serial No
             </label>
             <input
               type="text"
               className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
               placeholder="Enter Serial No"
               value={serialNumber}
               onChange={(e) => setSerialNumber(e.target.value)}
             />
           </div>

           {/* Device No */}
           <div>
             <label className="block text-sm font-medium text-gray-700">
               Device No
             </label>
             <input
               type="text"
               className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
               placeholder="Enter Device No"
               value={deviceNumber}
               onChange={(e) => setDeviceNumber(e.target.value)}
             />
           </div>

           {/* Type (Dropdown) */}
           <div>
             <label className="block text-sm font-medium text-gray-700">
               Type
             </label>
             <select
               className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
               value={deviceType}
               onChange={(e) => setDeviceType(e.target.value)}
             >
               <option value="" disabled>
                 Select Type
               </option>
               {deviceTypes.map((type) => (
                 <option key={type.value} value={type.value}>
                   {type.label}
                 </option>
               ))}
             </select>
           </div>

           {/* Details */}
           <div>
             <label className="block text-sm font-medium text-gray-700">
               Details
             </label>
             <input
               type="text"
               className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
               placeholder="Enter Details"
               value={details}
               onChange={(e) => setDetails(e.target.value)}
             />
           </div>
         </form>
         {/* <div className="flex justify-end mt-6 space-x-2">
           <button
             className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
             onClick={() =>setAddDevicemodal(false)}
           >
             Close
           </button>
           <button onClick={()=>addDevice()}
             className="px-4 py-2 bg-[#E17954] text-white rounded-md hover:bg-blue-600"
        
           >
             Save
           </button>
         </div> */}
           </div>}
          </div>
        </div>
      )}
    </>
  );
};

export default EnrollPatient;
